import * as e from "react";
import a from "../lib/IconBase.es.js";
import i from "../defs/DotsThreeOutlineVertical.es.js";
const t = e.forwardRef((o, r) => /* @__PURE__ */ e.createElement(a, { ref: r, ...o, weights: i }));
t.displayName = "DotsThreeOutlineVerticalIcon";
const n = t;
export {
  n as DotsThreeOutlineVertical,
  t as DotsThreeOutlineVerticalIcon
};
